import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modal, subscribe } from 'actions';
import { t } from 'translates';
import {Form} from "react-final-form";
import ReCAPTCHA from 'react-google-recaptcha';
import TencentCaptcha from 'react-tencent-captcha';
import Portal from 'common/components/Portal';
import Field from 'common/components/Form/Field';
import Spinner from 'common/components/Spinner';

class Subscribe extends Component {
  static propTypes = {
    product_id: PropTypes.string.isRequired,
    modal: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    number_of_places: PropTypes.string.isRequired,
    spinner: PropTypes.bool.isRequired,
    email: PropTypes.string,
    url: PropTypes.string,
    actions: PropTypes.shape({
      modal: PropTypes.object,
      subscribe: PropTypes.object,
    }).isRequired,
    captcha: PropTypes.shape({
      type: PropTypes.string,
      key: PropTypes.string,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.onSubmit = ::this.onSubmit;
    this.close = ::this.close;
    this.onChangeCaptcha = :: this.onChangeCaptcha;
    this.captchaRef = React.createRef();
    this.formValues = {}
  }

  static validate({ places, email }) {
    const errors = {};
    const required = 'Required';
    if (!places && places !== '0') {
      errors.places = required;
    }
    if (!email) {
      errors.email = required;
    }

    return errors;
  }

  async onSubmit({ ...values }) {
    this.formValues = values

    if (this.props.captcha && this.props.captcha.type === 'google') {
      this.captchaRef.current.execute();
    } else {
      this.captchaRef.current.instance.show();
    }
  }

  close(e) {
    e.preventDefault();

    this.props.actions.modal.hide('subscribe.dialog');

    return false;
  }

  get persons() {
    const {
      number_of_places,
    } = this.props;

    const maxNumberOfPlaces = parseInt(number_of_places);

    return (
      <Field
        type="select"
        name="places"
      >
        <option value="" key={0}>{t('Number of participants', DT_SUBSCRIBE)}</option>
        {new Array(maxNumberOfPlaces).fill(1).map((_, i) => (
          <option
            key={i + 1}
            value={i + 1}
          >
            {`${i + 1} ${t('Pers.', DT_SUBSCRIBE)}`}
          </option>
        ))}
      </Field>
    );
  }

  onChangeCaptcha(value) {
    if (this.props.captcha && this.props.captcha.type === 'google') {
      value = {
        hash: value
      }
    }
    this.props.actions.subscribe.postSubscribe({
      ...this.formValues,
      captcha: value
    });
  }

  render() {
    const {
      email, spinner, modal, isOpen,
      captcha: {
        key: captchaKey = '',
        type: captchaType = ''
      } = {}
    } = this.props;

    const { isOpen: messageOpen, message, type = 'success' } = modal['subscribe.message']

    const places = 0;

    const product = this.props.product_id;

    return (
      <div>
        <Portal
          id="subscribe.dialog"
          className="dialog__portal subscribe-dialog__portal"
          onClose={this.close}
          isOpen={isOpen}
        >
          <div className="dialog subscribe-dialog">
            <div className="dialog__header">
              <div className="dialog__title">
                {t('Subscribe to waitlist', DT_SUBSCRIBE)}
              </div>
              <button className='dialog__close' type='button' onClick={this.close} />
            </div>
            <div className="dialog__body">
              {spinner &&
                <Spinner />
              }
              { messageOpen ? (
                <p className='subscribe-dialog__message'>
                  {type === 'success' && (
                    <span>{t('You have subscribed to the waitlist successfully', DT_SUBSCRIBE)}</span>
                  )}
                  {type !== 'success' && (
                    <span>{message}</span>
                  )}
                </p>
              ) : (
                <Form
                  onSubmit={this.onSubmit}
                  initialValues={{
                    email,
                    places,
                    product
                  }}
                  validate={Subscribe.validate}
                >
                  {({ handleSubmit, form, invalid }) => (
                    <form
                      className='subscribe-dialog__form'
                      onSubmit={handleSubmit}
                    >
                      <div className="subscribe-dialog__form-field">
                          { this.persons }
                      </div>
                      <div className="subscribe-dialog__form-field">
                        <Field
                          type="email" name="email"
                          placeholder={t('Your e-mail address', DT_SUBSCRIBE)}
                          pattern="@"
                          value={email}
                        />
                      </div>

                      <button
                        type="submit"
                        className="subscribe-dialog__form-submit"
                        disabled={invalid}
                      >
                        {t('Subscribe', DT_SUBSCRIBE)}
                      </button>

                      <p className="subscribe-dialog__form-desc">
                        {t('By entering your email, you agree to be contacted by email and you agree to our terms and conditions & privacy policy.', DT_SUBSCRIBE)}
                      </p>
                        {captchaType === 'google' ? (
                          <ReCAPTCHA
                            ref={this.captchaRef}
                            sitekey={captchaKey}
                            size="invisible"
                            badge="inline"
                            onChange={this.onChangeCaptcha}
                          />
                        ) : (
                          <TencentCaptcha
                            appId={captchaKey}
                            options={{}}
                            onCallBack={this.onChangeCaptcha}
                            ref={this.captchaRef}
                          />
                        )}
                    </form>
                  )}
                </Form>
              )}
            </div>
          </div>
        </Portal>
      </div>
    );
  }
}

export default connect(
  state => ({
    isOpen: state.modal['subscribe.dialog'].isOpen,
    modal: state.modal,
    ...state.subscribe,
  }),
  dispatch => ({
    actions: {
      modal: bindActionCreators(modal, dispatch),
      subscribe: bindActionCreators(subscribe, dispatch),
    },
  }),
)(Subscribe);
